import { PmiButton } from 'shell/components/shared/button';
import { Grid } from '@mui/material';
import { memo } from 'react';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

interface ButtonsProps {
  handleExit: () => void;
}

const ButtonsComponent = ({ handleExit }: ButtonsProps): React.ReactElement => {
  return (
    <StickyDiv>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <StepButton variant="outlined" color="cdmBrandThird" fullWidth active>
            <StepTypography active>Documenti</StepTypography>
          </StepButton>
        </Grid>
      </Grid>
      <div className="pmi-pt-3">
        <PmiButton variant="outlined" color="cdmBrand" fullWidth onClick={handleExit}>
          Indietro
        </PmiButton>
      </div>
    </StickyDiv>
  );
};

ButtonsComponent.displayName = 'Reprint CID Page - Buttons';

const Buttons = memo(ButtonsComponent);

export default Buttons;
